<template>
  <div class="col-md-12">
    <div class="title-heading d-flex justify-content-between">
      <h1>{{ $static('s-password.title', 'Зміна паролю') }}</h1>
    </div>
    <div class="panel panel-bordered">

      <div class="row row-device">
        <div class="col-lg-2"></div>
        <div class="col-lg-8">
          <div class="panel mb-0">
            <div class="form-group">
              <label class="custom-label">{{ $static('s-password.old-password', 'Старий пароль:') }}</label>
              <input type="password" class="form-control custom-input" v-model="obj.old_pass">
            </div>
            <div class="form-group">
              <label class="custom-label">{{ $static('s-password.new-password', 'Новий пароль:') }}</label>
              <input type="password" class="form-control custom-input" v-model="obj.new_pass">
            </div>
            <div class="form-group">
              <label class="custom-label">{{ $static('s-password.new-password2', 'Підтвердити новий пароль:') }}</label>
              <input type="password" class="form-control custom-input" v-model="obj.confirm_pass">
            </div>
            <button class=" default-btn btn-accent" @click="save">
              <span class="text">{{ $static('s-b.save', 'Зберегти зміни') }}</span>
            </button>
          </div>
        </div>
        <div class="col-lg-2"></div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'SettingsApi',
  components: {},
  data() {
    return {
      obj: {
        old_pass: '',
        new_pass: '',
        confirm_pass: ''
      }
    }
  },
  mounted() { },
  computed: {},
  methods: {
    save() {
      api.post(`/api/password`, this.obj).then(response => response.data).then(data => {
        if (data.error) {
          this.$notify({
            title: this.$static('notify.password-title', 'Пароль'),
            type: 'error',
            text: data.error
          });
        } else {
          this.$notify({
            title: this.$static('notify.password-title', 'Пароль'),
            text: this.$static('notify.save', 'Збережено.')
          });
          this.obj = {
            old_pass: '',
            new_pass: '',
            confirm_pass: ''
          }
        }
      });
    }
  }
}
</script>

<style scoped></style>